import { crewMemberNoData, EMPLOYMENT_TYPE_MAP } from '../const';

/**
 * @param {import('./deriveClassification').EmploymentType | null | undefined} employmentType
 * @returns {string}
 */
export const deriveEmploymentTypeLabel = (employmentType) => {
	if (!employmentType) return crewMemberNoData;
	return EMPLOYMENT_TYPE_MAP[employmentType.employmentType] ?? crewMemberNoData;
};
